"use client";
import React from "react";
import { Provider, createStore } from "jotai";
import { userAtom } from "@/utils/store/atoms";

const store = createStore();
store.sub(userAtom, () => {});

export default function Providers({ children }: { children: any }) {
    return <Provider store={store}>{children}</Provider>;
}
